const listBikesMock = [
    {    
        "name": "PACKD E-go",
        "price": 1799,
        "brand": "Batavus",
        "power": "electric",
        "type": "mountain",
        "link": "https://www.batavus.be/elektrische-fietsen/packd-e-go#BE101571",
        "image": "001.jpg"
    },
    {
        "name": "CityGo C7",
        "price": 2399,
        "brand": "Gazelle",
        "power": "electric",
        "type": "city & touring",
        "link": "https://www.gazellebikes.com/nl-be/citygo-c7-hms#pim_itemcolorcodeonergb=0%2C0%2C0&pim_itemgenderframe=Laag&color=color-black",
        "image": "002.jpg"
    },
    {
        "name": "Image Lite",
        "price": 899,
        "brand": "Kalkhoff",
        "power": "manual",
        "type": "city & touring",
        "link": "https://www.kalkhoff-bikes.com/nl_be/kh0130023v2022-image-lite",
        "image": "003.jpg"
    },
    {
        "name": "Image 1B move",
        "price": 2699,
        "brand": "Kalkhoff",
        "power": "electric",
        "type": "city & touring",
        "link": "https://www.kalkhoff-bikes.com/nl_be/kh0050065v2022-image-1-b-move-blx",
        "image": "004.jpg"
    },
    {
        "name": "Image 3B move",
        "price": 3099,
        "brand": "Kalkhoff",
        "power": "electric",
        "type": "city & touring",
        "link": "https://www.kalkhoff-bikes.com/nl_be/kh0050083v2022-image-3-b-move",
        "image": "005.jpg"
    },
    {
        "name": "Endeauvour 24",
        "price": 999,
        "brand": "Kalkhoff",
        "power": "manual",
        "type": "city & touring",
        "link": "https://www.kalkhoff-bikes.com/nl_be/kh0110015v2022-endeavour-24",
        "image": "006.jpg"
    },
    {
        "name": "Endeavour 5B",
        "price": 4499,
        "brand": "Kalkhoff",
        "power": "electric",
        "type": "city & touring",
        "link": "https://www.kalkhoff-bikes.com/nl_be/kh0020061v2022-endeavour-5-b-advance",
        "image": "007.jpg"
    },
    {
        "name": "Touring One",
        "price": 749,
        "brand": "Cube",
        "power": "manual",
        "type": "city & touring",
        "link": "https://www.cube.eu/nl/2022/bikes/city-tour/on-road/touring/cube-touring-one-greynblue-easy-entry/",
        "image": "008.jpg"
    },
    {
        "name": "Touring One 400",
        "price": 2449,
        "brand": "Cube",
        "power": "electric",
        "type": "city & touring",
        "link": "https://www.cube.eu/nl/2022/e-bikes/city-tour/on-road/touring-hybrid/cube-touring-hybrid-one-400-greynblue/",
        "image": "009.jpg"
    },
    {
        "name": "Touring Pro 625",
        "price": 3049,
        "brand": "Cube",
        "power": "electric",
        "type": "city & touring",
        "link": "https://www.cube.eu/nl/2022/e-bikes/city-tour/on-road/touring-hybrid/cube-touring-hybrid-pro-625-metallicgreynblack/",
        "image": "010.jpg"
    }
]

export default listBikesMock;